class StoreBadgeEvent {
  handleClickToggleButton(button: Element, wrapper: HTMLElement) {
    const rowId = button.getAttribute('data-row-id');

    button.addEventListener('click', () => {
      const storeBadge = wrapper.querySelector('[data-row-id="' + rowId + '"]')
      if (button.classList.contains('expand-button')) {
        storeBadge?.classList.remove('partial-display');
        button.classList.add('hidden');
        button.nextElementSibling?.classList.remove('hidden');
      } else {
        storeBadge?.classList.add('partial-display');
        button.classList.add('hidden');
        button.previousElementSibling?.classList.remove('hidden');
      }
    });
  };

  initialize(wrapper: HTMLElement) {
    const expandButtons = wrapper.querySelectorAll('.expand-button');
    const contractButtons = wrapper.querySelectorAll('.contract-button');

    expandButtons.forEach(button => {
      this.handleClickToggleButton(button, wrapper);
    });
    contractButtons.forEach(button => {
      this.handleClickToggleButton(button, wrapper);
    });
  }
}

export default StoreBadgeEvent;
